import { Injectable } from '@angular/core';
import { TokenRefreshService } from './token-refresh/token-refresh-service';
import { ActiveSecurityContextStateService } from './active-security-context.state-service';
import { firstValueFrom } from 'rxjs';
import { LoggingService } from '@logging/logging.service';
import { UnityCookieService } from '@utils/unity-cookie.service';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthInitializerService {
  constructor(
    private tokenRefreshService: TokenRefreshService,
    private activeSecurityContextState: ActiveSecurityContextStateService,
    private cookieService: UnityCookieService,
    private logger: LoggingService,
    private authenticationService: AuthenticationService
  ) {}

  async initializeAuth(): Promise<void> {
    try {
      if (!this.cookieService.getRefreshToken()) {
        this.logger.debug('No refresh token found during initialization');
        this.clearAuthState();
        return;
      }

      const authenticated = await firstValueFrom(this.tokenRefreshService.ensureAuthenticated$());

      if (authenticated) {
        this.logger.debug('Successfully restored auth state during initialization');
        return;
      }

      this.logger.error('Failed to refresh auth state during initialization');
      this.clearInMemoryAuthState();
    } catch (error: any) {
      this.logger.error('Error during auth initialization:', error?.message || error);
      this.clearInMemoryAuthState();
    }
  }

  clearAuthState(): void {
    this.clearInMemoryAuthState();
    this.cookieService.clearAuthState();
  }

  private clearInMemoryAuthState(): void {
    this.activeSecurityContextState.clearActiveAuthState();
    this.authenticationService.setActiveIdentity(undefined);
  }
}
